import { formatISO } from "date-fns";
import { UseFormSetError } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { dbQueries, useAuth, useInitializeOfflineMode } from "duck";
import { AccessStatusEnum } from "requests";
import { FormValues } from "./types";

export const useLogin = () => {
  const navigate = useNavigate();

  const initialize = useInitializeOfflineMode();
  const [, setAuth] = useAuth();

  return ({ pin }: FormValues, setError: UseFormSetError<FormValues>) =>
    dbQueries
      .loadUser(pin)
      .then(user => {
        const time = formatISO(new Date());

        if (!user) {
          setError("pin", { message: "PIN is wrong. Please try again." });
          dbQueries.addLog({
            status: AccessStatusEnum.Unsuccessful,
            time
          });
          return;
        }

        dbQueries.addLog({ status: AccessStatusEnum.Successful, time });

        initialize(user);
        setAuth({ loading: false, user });
        navigate("/cases", { replace: true });
      })
      .catch(() => {
        setError("pin", { message: "PIN is wrong. Please try again." });
        dbQueries.addLog({
          status: AccessStatusEnum.Unsuccessful,
          time: formatISO(new Date())
        });
      });
};
